export default "__VITE_ASSET__BHCCbTlc__"